import React from 'react'
import Select from 'react-select';
import { useStateContext } from '../contexts/ContextProvider';

const MySelect = ({ label, labelAr, placeholder, value, getOptionLabel, getOptionValue, options, onInputChange, onChange }) => {
    const { setToken, user, } = useStateContext();
    return (
        <div className='flex-col w-full'>
            <div className="flex">
                <label className="block text-sm font-medium leading-6 text-gray-900">{label} <span className='text-red-500'> *</span></label>
            </div>
            <Select className='mt-2 outline-1 ' placeholder={placeholder} cacheOptions defaultOptions value={value} getOptionLabel={getOptionLabel} getOptionValue={getOptionValue} options={options} onInputChange={onInputChange} onChange={onChange} />
        </div>
    )
}

export default MySelect